export const countdown = (dateTo) => {
  const countdownEl = document.querySelector('.countdown');
  if(countdownEl) {
    const daysEl = countdownEl.querySelector('#days');
    const hoursEl = countdownEl.querySelector('#hours');
    const minutesEl = countdownEl.querySelector('#minutes');
    const secondsEl = countdownEl.querySelector('#seconds');
    
    const pad2 = v => String(v).padStart(2,'0');

    let prev = {d:null,h:null,m:null,s:null};
    let interval = null;

    const update = () => {
      const now = new Date();
      let diff = Math.max(0, dateTo - now);

      const days = Math.floor(diff / (24*60*60*1000));
      diff -= days * (24*60*60*1000);
      const hours = Math.floor(diff / (60*60*1000));
      diff -= hours * (60*60*1000);
      const minutes = Math.floor(diff / (60*1000));
      diff -= minutes * (60*1000);
      const seconds = Math.floor(diff / 1000);

      const setIfChanged = (node, text, key, prevObj) => {
        if(prevObj[key] === text) return;
        prevObj[key] = text;
        node.textContent = text;
      }


      setIfChanged(daysEl, pad2(days), 'd', prev);
      setIfChanged(hoursEl, pad2(hours), 'h', prev);
      setIfChanged(minutesEl, pad2(minutes), 'm', prev);
      setIfChanged(secondsEl, pad2(seconds), 's', prev);

      if(dateTo - now <= 0 && interval){
        clearInterval(interval);
        interval = null;
      }
    }

    update();
    if (interval) {
      clearInterval(interval)
    };

    interval = setInterval(update, 250);
  }
}